module.exports = __webpack_public_path__ + "img/pickup-agent.3580d564.svg";